export const CheckIcon = ({ className }: { className?: string }) => {
  return <img className={`${className}`} src="/assets/check.svg" alt="check icon" />;
};
